<template>
    <div class="grandDay">
        <img id="logo"
            src="https://firebasestorage.googleapis.com/v0/b/swanmoments-f3801.appspot.com/o/Boda%20Aviles%20Membre%C3%B1o%2Fgran%20dia%20icono.svg?alt=media&token=365e74ff-f4b4-4bef-930b-a4ab4770e1ab"
            alt="" style="width: 7rem">
        <p class="title">EL GRAN DÍA</p>
        <img style="width: 18rem;"
            src="https://firebasestorage.googleapis.com/v0/b/swanmoments-f3801.appspot.com/o/Boda%20Aviles%20Membre%C3%B1o%2Ffecha.svg?alt=media&token=a3fabd66-984a-48d8-be94-ab3ba355f1a5"
            alt="">
        <p style="text-align: center;"> {{ gday.TextoIntro }}</p>
        <br>
        <div class="cita">
            <p> Y dijo: Por esto el Hombre dejara a su Padre y a su Madre, y se unirá a su Esposa, y los dos serán una
                sola carne. Así que
                son ya más dos, si no una sola carne; por tanto, lo que Dios junto, no lo separe el Hombre.
            </p>
            <br>
            <p>Mateo 19: 5-6</p>
            <img
                src="https://firebasestorage.googleapis.com/v0/b/swanmoments-f3801.appspot.com/o/Boda%20Aviles%20Membre%C3%B1o%2Fcita%20biblica.svg?alt=media&token=b9ac6c9a-e36e-4c32-9089-ea74c7175354">
        </div>
        <br>
        <div id="containerCount">
            <!-- <img src="https://firebasestorage.googleapis.com/v0/b/swanmoments-f3801.appspot.com/o/Boda%20Aviles%20Membre%C3%B1o%2Fcuenta%20regresiva.svg?alt=media&token=ba721648-b2d0-42a1-95a6-160988318218"> -->
            <div class="count">
                <div class="textCount">
                    <p class="title">Sólo faltan...</p>
                </div>
                <div class="time">
                    <span class="numeros" id="days">0</span>
                    <p>Días</p>
                </div>
                <div class="time">
                    <span class="numeros" id="hours">0</span>
                    <p>Horas</p>
                </div>
                <div class="time">
                    <span class="numeros" id="minutes">0</span>
                    <p>Minutos</p>
                </div>
                <div class="time">
                    <span class="numeros" id="seconds">0</span>
                    <p>Segundos</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
export default {
    name: 'GrandDay',
    props: {
        Code: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            gday: {
                FechaHoraEvento: "2022-02-14T15:00:00",
                TextoIntro: "",
            },
            diferencial: this.$route.query.id,
        }
    },
    methods: {
        moment: function (date, format) {
            var _date = new Date(Date.parse(date));
            var utcDateString = _date.toUTCString();
            return moment.utc(utcDateString).locale("es-mx").format(`${format}`);
        },

        updateCountdown() {
            var DATE_TARGET = new Date(Date.parse(this.gday.FechaHoraEvento));
            const SPAN_DAYS = document.querySelector("span#days");
            const SPAN_HOURS = document.querySelector("span#hours");
            const SPAN_MINUTES = document.querySelector("span#minutes");
            const SPAN_SECONDS = document.querySelector("span#seconds");
            // Milliseconds for the calculations
            const MILLISECONDS_OF_A_SECOND = 1000;
            const MILLISECONDS_OF_A_MINUTE = MILLISECONDS_OF_A_SECOND * 60;
            const MILLISECONDS_OF_A_HOUR = MILLISECONDS_OF_A_MINUTE * 60;
            const MILLISECONDS_OF_A_DAY = MILLISECONDS_OF_A_HOUR * 24;

            // Calcs
            var NOW = new Date();
            var DURATION = DATE_TARGET - NOW;
            const REMAINING_DAYS = Math.floor(DURATION / MILLISECONDS_OF_A_DAY);
            const REMAINING_HOURS = Math.floor(
                (DURATION % MILLISECONDS_OF_A_DAY) / MILLISECONDS_OF_A_HOUR
            );
            const REMAINING_MINUTES = Math.floor(
                (DURATION % MILLISECONDS_OF_A_HOUR) / MILLISECONDS_OF_A_MINUTE
            );
            const REMAINING_SECONDS = Math.floor(
                (DURATION % MILLISECONDS_OF_A_MINUTE) / MILLISECONDS_OF_A_SECOND
            );

            // Render
            if (
                (SPAN_DAYS != null) &
                (SPAN_HOURS != null) &
                (SPAN_MINUTES != null) &
                (SPAN_SECONDS != null)
            ) {
                SPAN_DAYS.textContent = REMAINING_DAYS;
                SPAN_HOURS.textContent = REMAINING_HOURS;
                SPAN_MINUTES.textContent = REMAINING_MINUTES;
                SPAN_SECONDS.textContent = REMAINING_SECONDS;
            }
        },

        GetGrandDay() {
            let url = process.env.VUE_APP_API_DEV ? `${process.env.VUE_APP_API_DEV}Event/GetGrandDay/${this.Code}` : `${process.env.VUE_APP_API_PRO}Event/GetGrandDay/${this.Code}`;
            axios.get(url)
                .then((response) => this.gday = response.data)
                .catch(err => console.error(err));
        }
    },
    created() {
        setInterval(this.updateCountdown, 1000);
        this.GetGrandDay();
    },
    mounted() {
        setInterval(this.updateCountdown, 100);
    },
    updated() {
        this.updateCountdown();
        setInterval(this.updateCountdown, 100);
    },

}
</script>

<style scoped>
.cita {
    background-color: #A4AF97;
    text-align: center;
    padding: 2rem 1.5rem 1rem 1.5rem;
    width: 40rem;

    img {
        width: 5rem;
    }

    p {
        color: #fff;
        width: 80%;
        display: block;
        margin: auto;
    }
}

.grandDay {
    display: grid;
    grid-template-columns: 1fr;
    grid-column-gap: 0px;
    grid-row-gap: 0.5rem;
    place-items: center;
    color: var(--text);
}

#containerCount{
    position: relative;
}

.count {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-template-rows: 1fr;
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    place-items: center;
    border: solid 2px var(--btn);
    height: 10rem; 
    position: inherit;
    z-index: 1;
}

span.numeros {
    font-size: 2rem;
    color: var(--title);
    font-family: var(--titulos);
}

#day {
    font-size: 2.5rem;
    color: var(--title2);
    font-family: var(--titulos);
}

.time {
    text-align: center;
}

.time>p {
    color: var(--text) !important;
}

.textCount {
    text-align: center;
    background-color: var(--btn);
    height: 100%;
    width: 100%;
    color: #fff;
    display: grid;
    align-items: center;
}

.textCount>p {
    font-size: 1.5rem;
    font-family: var(--titulos);
    color: var(--btn-text);
    
}

.title {
    font-family: var(--font);
    color: var(--btn);
    font-size: 2.5rem;
    font-style: italic;
    text-transform: 400;
}

.grandDay>#logo {
    width: 5rem;
}


@media (max-width: 768px) {
    .cita {
        width: 100%;
    }

    #center-flower {
        display: none;
    }

    .count {
        grid-template-rows: 3rem 1fr;
        grid-template-columns: repeat(4, 1fr);
        width: 20rem;
    }

    p.textCount {
        width: 100%;
    }

    .textCount {
        grid-column: 1 / 5;
    }

    .textCount>p {
        font-size: 2rem !important;
    }

    .time>p {
        font-size: 0.8rem;
    }

}
</style>